// 收益列表
export function profit_list(options){
	return $ask.request.post('/admin/profit/list',options.data,options.options)
}
// 收入统计
export function profit_income(options){
	return $ask.request.post('/admin/profit/income',options.data,options.options)
}